import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AgeToCalendarSelect from '../AgeToCalendarSelect/AgeToCalendarSelect';
import Overlay from 'ps-components/SimpleModal/Overlay/Overlay';
import Button from 'ps-components/Button/Button';

import './AgeSelect.scss';

export default class AgeSelect extends Component {
  static propTypes = {
    ageToDate: PropTypes.string,
    defaultAgingDate: PropTypes.string,
    setAgeToDateHandler: PropTypes.func,
    benchmarkYear: PropTypes.number,
    className: PropTypes.string
  };

  constructor(props) {
    super(props);

    const NO_DATE_DEFAULT = 'Default';

    this.selectDate = this.selectDate.bind(this);
    this.toggleOverlay = this.toggleOverlay.bind(this);
    this.hideOverlay = this.hideOverlay.bind(this);
    this.unsetDate = this.unsetDate.bind(this);

    let date = this.props.ageToDate;

    if (date) {
      // the date is stored as an ISO8601 compliant string with hyphens,
      // but JavaScript is dumb sometimes and if you store 2017-07-01 in the DB
      // and try to generate a Date object from that string you get Jun 30, 2017
      // but creating a new Date object with 2017/07/01 works
      const dateObject = new Date(date.replace(/-/g, '/'));

      date = this.getUserFriendlyDate(dateObject);
    }

    this.state = {
      noDateDefault: NO_DATE_DEFAULT,
      selectedDate: date,
      showOverlay: false
    };
  }

  hideOverlay() {
    this.setState({
      showOverlay: false
    });
  }

  toggleOverlay() {
    //New Mantine calendar might need more than one click
    //keep the calendar overlay and Profile Dropdown open till the time 
    //user selects Date or selects Default
    this.props.getShowOverlay(!this.state.showOverlay);
    this.setState({
      showOverlay: !this.state.showOverlay
    });

  }

  unsetDate() {
    const previousDate = this.state.selectedDate;

    this.setState({
      selectedDate: null,
      showOverlay: false
    });

    this.props
      .setAgeToDateHandler({
        ageToDate: null
      })
      .then(result => {
        if (!result.success) {
          this.setState({
            selectedDate: previousDate
          });

          alert('Something went wrong setting the age to date. Please refresh the page and try again.');
        }
      });
      this.props.getShowOverlay(false);
  }

  getUserFriendlyDate(date) {
    const month = date.getMonth();
    const day = date.getDate();
    const year = date.getFullYear();

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    return `${months[month]} ${day}, ${year}`;
  }

  selectDate(date) {
    const previousDate = this.state.selectedDate;
    const month = date.getMonth();
    const day = date.getDate();
    const year = date.getFullYear();

    const userFriendlyDate = this.getUserFriendlyDate(date);
    const iso8601Date = `${year}-${month + 1}-${day}`;

    this.setState({
      selectedDate: userFriendlyDate,
      showOverlay: false
    });
    this.props.getShowOverlay(false);
    this.props
      .setAgeToDateHandler({
        ageToDate: iso8601Date
      })
      .then(result => {
        if (!result.success) {
          this.setState({
            selectedDate: previousDate
          });

          alert('Something went wrong setting the age to date. Please refresh the page and try again.');
        }
      });
  }

  render() {
    return (
      <div className={this.props.className}>
        {/* <label className="switcher__label" htmlFor="age-to-date">
          Age To
        </label> */}
        <Button
          className="aging__action"
          ref={target => {
            this.target = target;
          }}
          onClick={this.toggleOverlay}
        >
          Aging: {this.state.selectedDate ? this.state.selectedDate : this.state.noDateDefault}
          <span className="caret" aria-hidden="true" />
        </Button>
        <Overlay id="age-to-date" className="aging__overlay" show={this.state.showOverlay} onHide={this.hideOverlay}>
          <AgeToCalendarSelect
            defaultAgingDate={this.props.defaultAgingDate}
            benchmarkYear={this.props.benchmarkYear}
            selectDate={this.selectDate}
            selectedDate={this.state.selectedDate}
            canReset={!this.state.selectedDate}
            reset={this.unsetDate}
          />
        </Overlay>
      </div>
    );
  }
}